import { createItem, deleteItem, listItems, updateItem } from './sharepoint';

const LIST = 'updates';

/**
 * Company-wide announcements surfaced on the Dashboard. Everyone with portal
 * access can read them; only Directors and Regional Managers can post, edit,
 * or delete (gated in the UI on the Dashboard).
 */
export async function listUpdates(opts) {
  return listItems(LIST, {
    orderby: 'fields/PostedAt desc',
    top: 25,
    ...opts,
  });
}

export const createUpdate = (model) => createItem(LIST, model);
export const updateUpdate = (id, model) => updateItem(LIST, id, model);
export const deleteUpdate = (id) => deleteItem(LIST, id);
